import React from "react"
import { Box, Progress } from "@carrotfertility/carotene-core"
import { BookingBreadcrumbs } from "../Breadcrumbs"

export function LoadingPage({ onReturnToProviderResults }: { onReturnToProviderResults?: () => void }) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        inlineSize: "100%",
        gap: theme.spacing(theme.tokens.spacing.lg),
        maxInlineSize: 640,
        blockSize: "100%"
      })}
    >
      <BookingBreadcrumbs onReturnToSearchResults={onReturnToProviderResults} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          blockSize: 200
        }}
      >
        <Progress />
      </Box>
    </Box>
  )
}
